<div class="flex flex-col gap-4" *ngIf="change.id === 0">
  <span class="font-semibold text-xl">Change Request History</span>

  <div>
    <mat-table [dataSource]="changeSource" matSort #changeSort="matSort" aria-label="In Home Care Changes" class="portal-table">
      <ng-container matColumnDef="licenseGuid">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">License</mat-header-cell>
        <mat-cell *matCellDef="let change">
          <span class="mobile-label">License</span>
          {{ change.licenseGuid }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Request</mat-header-cell>
        <mat-cell *matCellDef="let change">
          <span class="mobile-label">Request</span>
          {{ change.type }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="entity">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Entity</mat-header-cell>
        <mat-cell *matCellDef="let change">
          <span class="mobile-label">Entity</span>
          {{ sharedService.readableEntityTypes[change.entity] }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="approved">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Status</mat-header-cell>
        <mat-cell *matCellDef="let change">
          <span class="mobile-label">Status</span>
          <span *ngIf="change.approved">Approved</span>
          <span *ngIf="change.denied">Denied</span>
          <span *ngIf="!change.approved && !change.denied">Pending</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="effectiveDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Effective Date</mat-header-cell>
        <mat-cell *matCellDef="let change">
          <span class="mobile-label">Effective</span>
          {{ change.effectiveDateOfChange | date }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="changeColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: changeColumns"
               class="portal-interactive-row"
               [ngClass]="row.archived? 'portal-archived' : ''"
               (click)="selectChange(row)" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectChange(row))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectChange(row))"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" #changePaginator="matPaginator">
    </mat-paginator>
  </div>
</div>

<div *ngIf="change.id > 0" class="flex flex-col gap-4">
  <div class="flex flex-row gap-4 ml-auto">
    <button *ngIf="!change.approved && !change.denied" mat-raised-button color="warn" (click)="deleteChange(change)">Cancel Request</button>
    <button mat-raised-button color="warn" (click)="close()">Close</button>
  </div>

  <!--
    Change Entity Owner
  -->
  <div class="flex flex-col gap-4" *ngIf="change.entity === sharedService.entityOwner">
    <div class="flex flex-col font-semibold text-xl" *ngIf="change.type === sharedService.delete">
      Request to remove {{owner.firstName}} {{owner.lastName}} as an owner of the agency.
    </div>
    <span class="flex flex-col font-semibold text-xl" *ngIf="change.type !== sharedService.delete">
      Request to {{change.type === sharedService.add? ' add an ' : ' change the '}} owner to the agency.
    </span>

    <div class="flex flex-col md:flex-row md:w-1/2" *ngIf="change.type === sharedService.change && change.subunits.length > 0">
      <div class="flex flex-col md:w-1/2">
        <span class="font-semibold text-lg">Subunits being transferred</span>
        <div *ngFor="let subunit of change.subunits">{{subunit}}</div>
      </div>
      <div class="flex flex-col md:w-1/2" *ngIf="change.newParent">
        <span class="font-semibold text-lg">New Parent</span>
        <span>{{change.newParent}}</span>
      </div>
    </div>

    <div class="flex flex-col md:flex-row md:gap-4">
      <entity-owner *ngIf="change.type !== sharedService.delete"
                    class="md:w-1/2"
                    [entityId]="change.id"
                    [entityType]="sharedService.inHomeCareChange"
                    [entityGuid]="change.licenseGuid"
                    [isChange]="true">
      </entity-owner>
      <document class="md:w-1/2"
                [entityId]="change.id"
                [entityType]="sharedService.inHomeCareChange">
      </document>
    </div>
  </div>

  <!--
    Change Administrator
  -->
  <div class="flex flex-col gap-4" *ngIf="change.entity === sharedService.administratorApplication">
    <span class="flex flex-col font-semibold text-xl">Request to change the administrator.</span>
    <administrator-application [entityId]="change.id"
                                [entityType]="sharedService.inHomeCareChange">
    </administrator-application>
  </div>

  <!--
    Set As Parent Agency
  -->
  <div class="flex flex-col" *ngIf="change.entity === sharedService.parent">
    <span class="flex flex-col font-semibold text-xl">Request to set {{change.newValue}} as the parent agency.</span>
    <span>Current Parent Agency: {{change.originalValue}}</span>
    <span>New Parent Agency: {{change.newValue}}</span>
  </div>

  <!--
    Change Branch Operation
  -->
  <div class="flex flex-col" *ngIf="change.entity === sharedService.branchOperation">
    <div class="flex flex-col gap-2" *ngIf="change.type === sharedService.add">
      <span class="flex flex-col font-semibold text-xl">Request to add a branch operation</span>
      <branch-operation *ngIf="change.entity === sharedService.branchOperation"
                        [entityId]="change.id"
                        [entityType]="sharedService.inHomeCareChange">
      </branch-operation>
    </div>

    <div class="flex flex-col gap-2" *ngIf="change.type === sharedService.change">
      <span class="font-semibold text-xl">Request for change of branch physical address.</span>

      <span>Current Address</span>
      <div class="flex flex-col md:flex-row md:gap-2">
        <span class="font-semibold">{{address.street}}</span>
        <span class="font-semibold">{{address.city}}, {{address.state}} {{address.zip}}</span>
        <span class="font-semibold">{{address.county}}</span>
      </div>

      <address class="mt-4"
                [entityId]="change.id"
                [entityType]="sharedService.inHomeCareChange"></address>
    </div>
  </div>

  <!--
    Change Classification
  -->
  <div class="flex flex-col gap-4" *ngIf="change.entity === sharedService.classification">
    <span class="flex flex-col font-semibold text-xl">Request to change classification</span>
    <div class="flex flex-row gap-2">
      <span class="md:w-1/6">Current classification</span>
      <span class="font-semibold">{{change.originalValue}}</span>
    </div>
    <div class="flex flex-row gap-2">
      <span class="md:w-1/6">New classification</span>
      <span class="font-semibold">{{change.newValue}}</span>
    </div>

    <document class="md:w-1/2"
              [entityId]="change.id"
              [entityType]="sharedService.inHomeCareChange">
    </document>
  </div>

  <!--
    Change Nurse
  -->
  <div class="flex flex-col gap-4" *ngIf="change.entity === sharedService.nurse">
    <span class="font-semibold text-xl">Request to change the registered nurse</span>
    <div class="flex flex-row gap-2">
      <span class="md:w-1/12">Current Nurse</span>
      <span class="font-semibold">{{change.originalValue}}</span>
    </div>
    <div class="flex flex-row gap-2">
      <span class="md:w-1/12">New Nurse</span>
      <span class="font-semibold">{{change.newValue}}</span>
    </div>
  </div>

  <!--
    Change Address
  -->
  <div class="flex flex-col" *ngIf="change.entity === sharedService.address">
    <span class="flex flex-col font-semibold text-xl pb-4">Request for change of physical address.</span>

    <span>Current Address</span>
    <div class="flex flex-col md:flex-row md:gap-2">
      <span class="font-semibold">{{address.street}}</span>
      <span class="font-semibold">{{address.city}}, {{address.state}} {{address.zip}}</span>
      <span class="font-semibold">{{address.county}}</span>
    </div>

    <span class="pt-4">Requested Address</span>
    <address class="mt-4"
              [entityId]="change.id"
              [entityType]="sharedService.inHomeCareChange"></address>
  </div>

  <!--
    Status
  -->
  <div class="flex flex-col gap-4">

    <div class="flex flex-col md:flex-row gap-4">
      <div class="flex flex-col md:w-1/5">
        <span class="font-semibold">Status</span>
        <span>{{change.approved? 'Approved' : change.denied? 'Denied' : 'Pending'}}</span>
      </div>
    </div>

    <div class="flex flex-col md:flex-row gap-4">
      <div class="flex flex-col md:w-1/5">
        <span class="font-semibold">Administrator Signaure</span>
        <span>{{change.signature}}</span>
      </div>

      <div class="flex flex-col">
        <span class="font-semibold">Title</span>
        <span>{{change.title}}</span>
      </div>
    </div>

    <div class="flex flex-col md:flex-row gap-4">
      <div class="flex flex-col md:w-1/5">
        <span class="font-semibold">Effective Date</span>
        <span>{{change.effectiveDateOfChange | date}}</span>
      </div>

      <div class="flex flex-col">
        <span class="font-semibold">Date Signed</span>
        <span>{{change.dateSigned | date}}</span>
      </div>
    </div>
  </div>
</div>
